import React from 'react';
import { Card } from '../ui/Card';
import { Select } from '../ui/Select';
import { Toggle } from '../ui/Toggle';
import { Input } from '../ui/Input';
import { useWizard } from '../../hooks/useWizard';
export function WizardStep5Checkout() {
  const {
    data,
    updateStep5
  } = useWizard();
  const step5Data = data.step5;
  return <div className="space-y-6" data-id="element-561">
      <Card title="Fulfillment" description="How will customers receive their orders?" data-id="element-562">
        <div className="space-y-6" data-id="element-563">
          <Select label="Fulfillment Mode" value={step5Data.fulfillmentMode} onChange={e => updateStep5({
          fulfillmentMode: e.target.value as any
        })} options={[{
          value: 'ship-to-home',
          label: 'Ship to Home (Individual Shipping)'
        }, {
          value: 'bulk-ship',
          label: 'Bulk Ship to Organization'
        }, {
          value: 'hybrid',
          label: 'Hybrid (Customer Chooses)'
        }]} data-id="element-564" />

          {(step5Data.fulfillmentMode === 'bulk-ship' || step5Data.fulfillmentMode === 'hybrid') && <div className="bg-gray-50 p-4 rounded-md border border-gray-200" data-id="element-565">
              <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-566">
                Bulk Shipping Address
              </h4>
              <p className="text-sm text-gray-500 mb-2" data-id="element-567">
                Enter the organization's default delivery address.
              </p>
              <Input placeholder="123 School Lane, Springfield, IL 62704" value={step5Data.bulkShippingAddress} onChange={e => updateStep5({
            bulkShippingAddress: e.target.value
          })} data-id="element-568" />
            </div>}
        </div>
      </Card>

      <Card title="Checkout Fields" description="Information to collect from customers at checkout." data-id="element-569">
        <div className="space-y-4" data-id="element-570">
          <Toggle label="Require Email" checked={step5Data.requireEmail} onChange={checked => updateStep5({
          requireEmail: checked
        })} description="Always required for order confirmation." data-id="element-571" />
          <Toggle label="Collect Phone Number" checked={step5Data.collectPhone} onChange={checked => updateStep5({
          collectPhone: checked
        })} data-id="element-572" />
          <Toggle label="Collect Student Name" checked={step5Data.collectStudentName} onChange={checked => updateStep5({
          collectStudentName: checked
        })} description="Useful for school distribution." data-id="element-573" />
          <Toggle label="Collect Grade / Teacher" checked={step5Data.collectGradeTeacher} onChange={checked => updateStep5({
          collectGradeTeacher: checked
        })} data-id="element-574" />
        </div>
      </Card>

      <Card title="Payments" data-id="element-575">
        <div className="space-y-4" data-id="element-576">
          <div className="flex items-center justify-between p-3 border border-gray-200 rounded-md bg-gray-50" data-id="element-577">
            <span className="text-sm font-medium text-gray-900" data-id="element-578">
              Credit Card
            </span>
            <span className="text-xs text-green-600 font-medium bg-green-100 px-2 py-1 rounded-full" data-id="element-579">
              Enabled
            </span>
          </div>
          <Toggle label="Allow Invoice / Pay Later" checked={step5Data.allowInvoice} onChange={checked => updateStep5({
          allowInvoice: checked
        })} description="Allow customers to checkout without immediate payment." data-id="element-580" />
        </div>
      </Card>
    </div>;
}